import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// Deliverable sets store state and actions
interface GlobalSearchStore {
  // State
  dialogOpen: boolean

  // Actions
  setDialogOpen: (open: boolean) => void
  reset: () => void
}

// Initial state
const initialState = {
  dialogOpen: false,
}

export const useGlobalSearchStore = create<GlobalSearchStore>()(
  devtools(
    (set) => ({
      ...initialState,

      /**
       * Set dialog open/close state
       */
      setDialogOpen: (open: boolean) => {
        set({ dialogOpen: open }, false, 'setDialogOpen')
      },

      /**
       * Reset store to initial state
       */
      reset: () => {
        set(initialState, false, 'reset')
      },
    }),
    {
      name: 'GlobalSearchStore',
    }
  )
)
